var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUploadFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#18a1db",
    d: "M10.388 4.1h2.207L9.216.545v2.379c0 .644.523 1.176 1.172 1.176z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#18a1db",
    d: "M6.53 14.607c0 .847.172 1.658.483 2.379h-5.43A1.597 1.597 0 0 1-.02 15.377V1.627C-.02.73.692 0 1.584 0h6.911v2.924c0 1.04.847 1.897 1.893 1.897h2.703v3.703c-.18-.013-.302-.027-.45-.027a6.203 6.203 0 0 0-4.078 1.55H2.809a.362.362 0 0 0-.36.36c0 .2.162.361.36.361h5.07c-.38.496-.686.991-.915 1.577H2.809a.362.362 0 0 0-.36.36c0 .199.162.36.36.36h3.916a6.012 6.012 0 0 0-.194 1.542zM2.45 8.155c0 .198.162.36.36.36h4.564c.199 0 .36-.162.36-.36a.362.362 0 0 0-.36-.36H2.81a.362.362 0 0 0-.36.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#18a1db",
    d: "M18.02 14.616A5.39 5.39 0 0 1 12.636 20a5.39 5.39 0 0 1-5.384-5.384 5.39 5.39 0 0 1 5.384-5.384 5.39 5.39 0 0 1 5.384 5.384zm-2.478-.433l-2.64-2.834a.368.368 0 0 0-.532 0l-2.64 2.834a.362.362 0 0 0 .018.51.368.368 0 0 0 .514-.019l2.018-2.162v5.15c0 .198.162.36.36.36.199 0 .36-.162.36-.36v-5.146l2.01 2.163a.36.36 0 0 0 .505.018.377.377 0 0 0 .027-.514z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadFile);
export default __webpack_public_path__ + "static/media/icon-upload-file.8d09c4c7.svg";
export { ForwardRef as ReactComponent };